<template>
  <div
    v-if="isexist"
    :class="['toolbar', `${request_prefix}-toolbar`, isAdmin ? 'admin' : '']"
    :style="computedStyle"
    @click="toolbarClick"
  >
    <el-breadcrumb separator-class="icon-portal-arrows-right" v-if="handleList && handleList.length" class="element-crumbs">
      <el-breadcrumb-item
        v-for="(handle, index) in handleList"
        :key="index"
        @mousedown.native.stop="openLayoutComponentEdit(handle, index)"
        @mouseenter.native="mouseenterEv(handle, index)"
        @mouseleave.native="mouseleaveEv(handle, index)"
      >
        <!--  辉总意见：取消图标-->
        <!--        <span :class="'icon ' + handle.iconClass"> </span>-->
        {{ handle.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <!--   布局和通栏的名称需要一直显示，且不可编辑「锚点和头底也是通栏的一种」 -->
    <div class="toolbar-header" v-if="(options.name === 'cellLayoutComponent' || options.name === 'pageLayoutComponent' )  && !options.hideToolTipHeader && options.name !== 'grid'">
      {{handleList[handleList.length-1].name}}
    </div>
    <!-- 非布局和通栏的组件名称，可编辑 -->
    <div
      v-if="
        !options.hideToolTipHeader && options.name != 'cellLayoutComponent' && options.name != 'pageLayoutComponent' && options.name !== 'grid'
      "
      class="toolbar-header"
      @dragstart="dragstart"
      @dragend="dragend"
    >
      <span v-show="checkOptName" @click="backTopTitle" class="back_icon icon-portal-arrows-left mr8"></span>
      <span v-if="checkOptName" class="component-name">{{toolbarHeaderName}}</span>
      <el-tooltip
        v-else
        :disabled="showCheckIcon"
        class="item"
        effect="dark"
        content="重命名"
        placement="bottom"
        :open-delay="1000"
      >
        <span class="component-name-box">
          <span class="component-name-edit" v-show="!showCheckIcon" @click="editComponentName">
             <span class="component-name">{{toolbarHeaderName}}</span>
             <span class="icon-portal-edit"></span>
          </span>
          <input
            v-show="showCheckIcon"
            class="component-name-inp"
            type="text"
            ref="componentNameInp"
            :value="toolbarHeaderName"
            @focus="getComponentNameFocus($event)"
            @blur="showCheckIcon = false"
          />
        </span>
      </el-tooltip>
      <span class="icon icon-portal-check-small" v-if="showCheckIcon" @mousedown="changeComponentName('')"></span>
      <span class="icon icon-portal-close-small" v-if="showCheckIcon" @mousedown="changeComponentName('', 2)"></span>
    </div>
    <el-tabs
      :class="[options.onlyShowBaseSet ? 'hide_Header' : '', options.hideToolTipHeader ? 'hide-toolBar-header' : '', breadcrumbShow ? 'breadcrumb-show':'', options.hideToolTipHeader && options.name != 'cellLayoutComponent' && options.name != 'pageLayoutComponent' ? 'header-name-hide':'', isSingleSubHead ? 'hide_Header' : '']"
      ref="toolbarTabs"
      v-model="activeName"
      :disabled="ids === null"
      @tab-click="handleClick"
    >
      <el-tab-pane
        v-if="!alignHelperStatus && options.onlyShowSet && options.name"
        name="first"
        :label="(elementActive === null || elementActive === 'page') && subPagePreview ? '模板' : ''"
      >
        <component
          v-if="tabShow.first"
          :is="options.name + 'Setting'"
          :options="child_options"
          :container_id="container_id"
          :rect_id="rect_id"
          :activeType="activeType"
        ></component>
      </el-tab-pane>
      <el-tab-pane
        v-if="elementActive && !alignHelperStatus && !options.onlyShowSet && options.name"
        label="样式"
        :data-name="options.name + 'Setting'"
        :name="'first'"
      >
        <cx-slider
          class="rect-active-slider"
          v-if="showActiveType && statusOpened"
          label="状态"
          :value.sync="activeType"
          :options="currentActiveTypeOptions"
        />
        <div
          v-if="showActiveType && activeType === '3' && options.name !== 'navMenuVerticalComponent'"
          class="hover-same-active"
        >
          <el-checkbox v-model="hoverIsSameActive">同选中状态</el-checkbox>
        </div>
        <el-collapse v-if="tabShow.first" v-model="activeNames">
          <el-collapse-item
            v-if="
              elementActive &&
              !alignHelperStatus &&
              !options.onlyShowSet &&
              !options.onlyShowBaseSet &&
              !options.hasNoStyle &&
              child_options &&
              !child_options.disableSetColAndRow &&
              !child_options.loginType &&
              !checkOptName &&
              (!showActiveType || activeType === '1') &&
              styleOpened &&
              !(child_options.pluginName && child_options.pluginName.includes('renderTypeCol'))
            "
            @mousedown.native="collapseMouseDown($event, '1')"
            title="选择样式"
            name="1"
            class="padding_0"
          >
            <template slot="title">
              选择样式
              <span class="stop-blank" @click.stop></span>
              <div
                class="more-btn"
                @click.stop="moreClick()"
                v-if="(isSystemComponent || options.showProductStyle) && !subPageGaphic"
              >
                更多<i class="icon-portal-arrows-right"></i>
              </div>
            </template>
            <template>
              <!--产品组合的组件-->
              <product-component-style
                v-if="
                  (isSystemComponent && child_options.isIndependenceComponent) || options.showProductStyle
                "
                class="template-styles"
                :options="child_options"
                :styleOptions="options"
                :container_id="container_id"
                :rect_id="rect_id"
                @changeOption="getNewOptions"
                ref="localStyleComponent"
              />
              <!--原生组件-->
              <component
                v-else
                class="template-styles 234"
                :id="options.name + 'Style'"
                :is="options.name + 'Style'"
                :options="child_options"
                :container_id="container_id"
                :rect_id="rect_id"
                @changeOption="getNewOptions"
                ref="localStyleComponent"
              ></component>
            </template>
          </el-collapse-item>
          <component
            v-if="options.onlyShowSet ? tabShow.second : tabShow.first"
            :id="options.name + 'Setting'"
            :is="options.name + 'Setting'"
            :options="child_options"
            :container_id="container_id"
            :rect_id="rect_id"
            :activeType="activeType"
            :statusOpened.sync="statusOpened"
            :styleOpened.sync="styleOpened"
            @onHideHeader="onHideHeader"
            ref="setComponent"
          ></component>
        </el-collapse>
      </el-tab-pane>
      <!--列表页中的自由布局不需要显示设置的配置项，该配置项在页面进行配置-->
      <el-tab-pane label="设置" v-if="options.showConfig && !isLoginLayout && !isLoginName && options.name && !isSingleSubHead" name="seventh">
        <component
          v-if="tabShow.seventh"
          :data-id="tabShow.seventh"
          :is="options.name + 'Config'"
          :options="child_options"
          :container_id="container_id"
          :rect_id="rect_id"
          :key="rect_id + (ids ? ids.uid : '')"
        ></component>
      </el-tab-pane>
      <!--单元格数据这是需要存在，中间同步操作的时候 用了里面同步数据的模拟点击（同步数据逻辑太复杂）-->
      <el-tab-pane
        v-if="
          elementActive &&
          !alignHelperStatus &&
          !options.onlyShowSet &&
          !options.onlyShowBaseSet &&
          !options.hasNoData &&
          child_options &&
          !child_options.disableSetData &&
          !child_options.disableSetColAndRow &&
          options.name &&
          options.name !== 'container'
        "
        :label="
          isLoginEngineLayout || isLoginLayout || options.name === 'editorComponent'
            ? '设置'
            : dataSetLabel
        "
        :name="options.onlyShowSet ? 'third' : 'second'"
        :data-param="options.onlyShowSet"
      >
        <!-- v-show:同步单元格时需要手动掉一次查看数据响应，用的模拟点击 v-if找不到按钮-->
        <component
          v-show="options.onlyShowSet ? tabShow.third : tabShow.second"
          :is="options.name + 'Data'"
          :options="child_options"
          :container_id="container_id"
          :rect_id="rect_id"
        ></component>
      </el-tab-pane>
      <el-tab-pane
        label="动画"
        class="animate-tab-pane"
        v-if="
          elementActive && !alignHelperStatus && !options.hasNoAnimate  && !options.hideToolTipHeader
        "
        :name="options.onlyShowSet ? 'fifth' : 'fourth'"
      >
        <component
          v-if="options.onlyShowSet ? tabShow.fifth : tabShow.fourth"
          :is="isPhoneFullScreen && options.name === 'container' ? 'containerAnimate' : 'animateSet'"
          :option="child_options"
          :container_id="container_id"
          :rect_id="rect_id"
          :onlyShowScrollAnimate = "options.onlyShowScrollAnimate"
        ></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import "assets/css/options.css"

import {
  handleFindLayoutComponentOptions,
  handleFindLayoutComponentOptionsCols,
  findParentIds,
  isExist
} from "../../../utils/index.js"
import componentsMixIn from "./toolBarMixIn.js"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import $ from "jquery"
import { CATEGORY_MODE } from "@/consts/index.js"
import { toolbarMixins } from "core/materialLoader"
export default {
  mixins: [componentsMixIn],
  data() {
    return {
      componentName: "",
      publicId: "",
      activeNames: ["1"],
      collapseActiveNames: ["1"],
      colIsAutoLayout: false,
      tabShow: {
        first: true,
        second: false,
        third: false,
        fourth: false,
        fifth: false,
        sixth: false,
        seventh: false
      },
      activeName: "first",
      options: {},
      container_id: null,
      rect_id: null,
      screenW: window.screen.width,
      screenH: window.screen.height,
      computedStyle: {
        right: 0,
        top: "10vh"
      },
      startPosition: {},
      ids: null,
      changeElementType: true, //控制toolbar只有在组件类型发生改变时才会更新，避免事件操作时触发toolbar更新
      isInLayoutTitle: false, // 是否在layout的titleOptions内
      dataSetLabel: "",
      showCheckIcon: false,
      handleBtnStr: {
        iconClass: "",
        name: this.toolbarHeaderName
      },
      handleList: [],
      activeType: "1",
      activeTypeOptions: [
        { value: "1", title: "默认" },
        { value: "2", title: "选中" },
        { value: "3", title: "悬浮" }
      ],
      currentActiveTypeOptions: [],
      // 状态组件显示状态，可由子组件调整
      statusOpened: true,
      // 样式显示状态，可由子组件调整
      styleOpened: true,
      parentElementType:''
    }
  },
  mounted() {
    if (this.request_prefix === "bigScreen") {
      this.dataSetLabel = "数据管理"
    } else {
      this.dataSetLabel = "数据"
    }
  },
  watch: {
    isexist() {
      if (this.isexist) {
        Object.keys(this.tabShow).some((k, i) => {
          if (i === 0) {
            this.$set(this.tabShow, k, true)
          } else {
            this.$set(this.tabShow, k, false)
          }
        })
        this.activeName = "first"
      }
    },
    "$store.state.states.elementType"(n, o) {
      const map3DSubSettings = ["cxMap3DHot", "cxMap3DBar", "cxMap3DLines", "cxMap3DScatter"]
      this.parentElementType = map3DSubSettings.includes(n) ? "cxMap3D" : ""
      this.changeElementType = true
      this.tabShow = {
        first: true,
        second: false,
        third: false,
        fourth: false,
        fifth: false
      }
      this.getOptions()
      console.log("this.child_options",this.child_options)
    },
    "$store.state.states.activeID.pageLayoutId"(n, o) {
      this.getOptions()
    },
    "$store.state.states.activeGridId": {
      deep: true,
      immediate: true,
      handler(n, o) {
        //需要在当前事件循环的最后一刻且虚拟dom完成之后进行 是否处于事件编辑状态的校验
        this.$nextTick(() => {
          if(!n || isExist(this.$store.state.states.activeID.rect_id)){
            return
          }
            const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
            let grid, layoutId,pageLayoutId
            for(let i=0;i<pageLayoutList.length;i++){
              const gridLayout = pageLayoutList[i].layout.rows[0].options.gridLayout
              if (!gridLayout) break
              grid = gridLayout.find(grid=>grid.i === n)
              if(grid){
                layoutId = i
                pageLayoutId = `${i}_0`
                break
              }
            }
            if(!grid){
              return
            }
            this.handleList =[
              {
                name: "通栏",
                iconClass: "icon-portal-artboard_1",
                shape: "cxPageLayout",
                ids: {
                  "container_id": 0,
                  "pageLayoutId": layoutId
                }
              },
              {
                name: "内容区",
                iconClass: "icon-portal-container",
                shape: "cxPageLayoutCell",
                ids: {
                  "container_id": 0,
                  "pageLayoutId": pageLayoutId
                }
              },
              {
                name: '布局',
                ids: this.ids
              }
            ]
        })
      }
    },
    "$store.state.states.activeID": {
      deep: true,
      immediate: true,
      handler(n, o) {
        this.activeType = "1"
        console.log("activeID")
        //需要在当前事件循环的最后一刻且虚拟dom完成之后进行 是否处于事件编辑状态的校验
        this.$nextTick(() => {
          if(this.$store.state.states.activeGridId) {
            // 栅格激活状态变化
            return
          }
          if (!window.sessionStorage.getItem("isSettingEvent")) {
            this.getIds()
          }
          if (n && Object.keys(n || {}).length) {
            this.handleList =
              findParentIds(
                n,
                this.$store.state[this.request_prefix].page.pageLayoutType,
                this.$store.state[this.request_prefix]
              ) || []
            this.handleList.push({
              name: this.child_options.menuName || this.toolbarHeaderName,
              ids: this.ids
            })
          }  else {
            this.handleList.splice(1,this.handleList.length-1)
          }
          let isWaterFall = this.$store.state[this.request_prefix].page.isWaterFall  === 'waterFall' ? true : false
          isWaterFall && this.handleList.forEach(item=>{
            if(item.name?.trim() === '布局' && !isExist(item.ids.rect_id)){
              item.name = '内容区'
            }
          })
          console.log("handleList",this.handleList)
          this.removeLayoutHandle()
        })
      }
    },
    "options.name": {
      deep: true,
      immediate: true,
      handler(n, o) {
        // 自由布局在调整内容后，数据配置始终激活，方便在改变单元格后更新数据
        if (n === "emptyLayoutComponent") {
          this.tabShow.second = "true"
        }
      }
    },
    subPagePreview() {
      this.getOptions()
    }
  },
  computed: {
    isSingleSubHead() {
      return this.$store.state[this.request_prefix].page.isSubHeadPage &&
      this.child_options?.options?.inDocument === 'header' &&
      !this.$store.state[this.request_prefix].page.pageLayoutList.find(item => item.options.inDocument === 'relativeHeader')
    },
    isAdmin() {
      return this.$store.state.states.managerType === 1 ? true : false
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    showComponentName() {
      return this.$store.state.states.showComponentName
    },
    toolbarHeaderName: {
      get() {
        if (this.isSystemComponent && this.child_options?.isIndependenceComponent) {
          return this.child_options.name || this.child_options.menuName
        } else if (this.child_options?.isCustomComponent) {
          return this.child_options.name
        } else {
          if (this.child_options?.pluginName && this.child_options?.pluginName[0] == "loginLayoutComponent") {
            return "登录"
          } else if (this.child_options?.options?.enableBayWindow) {
            return "飘窗"
          } else if (this.child_options?.options?.smartServices) {
            return "智能客服"
          } else if (this.$store.state.states.elementType === 'cxPageLayoutComponent') {
            if (this.child_options?.options?.isAccordionLayoutRow) {
              return "手风琴布局"
            }
            if(this.child_options?.layout.rows.length>1){
              return "横向标签"
            }else{
              return "竖向标签"
            }
          } else {
            return this.child_options?.name || this.options?.lable || ""
          }
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "name", false)
      }
    },
    isLoginLayout() {
      if (this.child_options?.pluginName && this.child_options?.pluginName[0] == "loginLayoutComponent") {
        return true
      } else {
        return false
      }
    },
    isLoginName() {
      if (this.child_options?.loginType === "loginName") {
        return true
      } else {
        return false
      }
    },
    isLoginEngineLayout() {
      if (this.child_options?.pluginName && this.child_options?.pluginName[0] == "loginEngineComponentPlugin") {
        return true
      } else {
        return false
      }
    },
    // 登录框的标签
    isLoginTabs() {
      if (
        this.child_options?.tabsList &&
        this.child_options?.tabsList[0] &&
        this.child_options?.tabsList[0]?.name === "手机号登录"
      ) {
        return true
      } else {
        return false
      }
    },
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    },
    alignHelperStatus() {
      return this.$store.state.states.alignHelperStatus
    },
    isexist() {
      if (
        this.request_prefix === "bigScreen" ||
        this.request_prefix === "stage" ||
        this.request_prefix === "appStage"
      ) {
        return true
      }
      return this.$store.state.states.toolBarStatus
    },
    elementActive() {
      return this.$store.state.states.elementType
    },
    rectOptions() {
      const ids = this.$store.state.states.activeID
      const stage = this.$store.state[this.request_prefix]
      let rectAttr = this.getAttrById(stage, ids, "rect").options
      return rectAttr
    },
    child_options() {
      const ids = this.$store.state.states.activeID
      const stage = this.$store.state[this.request_prefix]
      if (ids.pageLayoutId !== null && typeof ids.pageLayoutId !== "undefined") {
        if(ids.rect_id !== null && typeof ids.rect_id !== "undefined"){
          console.log("pageLayoutComponent",this.getAttrById(stage, {...ids},'pageLayoutComponent'))
          return this.getAttrById(stage, {...ids},'pageLayoutComponent')
        }else{
          return this.getAttrById(stage, { pageLayoutId: ids.pageLayoutId }, "pageLayout")
        }
      }
      if (ids.container_id === null || typeof ids.container_id === "undefined") {
        return ""
      } else if (ids.rect_id === null || typeof ids.rect_id === "undefined") {
        //返回画布数据
        // this.getRectAttribute.call(this, ids)
        return this.getAttrById(stage, { container_id: ids.container_id }, "container")?.options
      } else if (typeof ids.elementInSwiperId === "number") {
        //返回轮播内的组件的数据
        return this.getAttrById(stage, ids, "elementInSwiper")
      } else if (typeof ids.directionIndex === "number") {
        //自由布局里面的title部分
        let rectAttr = this.getAttrById(stage, ids, "rect").options
        if (typeof ids.elementInAutoLayoutId === "number") {
          rectAttr = this.getAttrById(stage, ids, "elementInAutoLayout")
        }
        return rectAttr.titleOptions[ids.directionIndex].elementOptions.find(
          it => it.elementInLayoutId === ids.elementInLayoutId
        )?.options
      } else if (ids.elementInDataGridId) { // 数据列表单元格内部组件
        return this.getAttrById(stage, ids, "elementInDataGrid")
      } else if (ids.cellId && !ids.elementInDataGridId) { // 数据列表单元格
        return this.getAttrById(stage, ids, "dataGridCell")
      } else if (ids.uid === null || typeof ids.uid === "undefined") {
        if (typeof ids.elementInAutoLayoutId === "number") {// 自动布局里的组件
          return this.getAttrById(stage, ids, "elementInAutoLayout")
        } else {
          //返回普通组件的数据
          let tempOptions = this.getRectAttribute.call(this, ids)
          if(tempOptions.options.innerElement === "cxPageLayoutComponent"){
            return tempOptions.options?.layout? tempOptions.options?.layout.layout.rows[0] : {}
          }else{
            return tempOptions.options
          }
        }
      } else {
        //返回自由布局组件内的数据
        let pOptions
        const uid = ids.uid
        if (typeof ids.elementInAutoLayoutId === "number" && !pOptions) { // 查找当前自由布局
          pOptions = this.getAttrById(stage, ids, "elementInAutoLayout")?.rows
        }else {
          pOptions = this.getRectAttribute.call(this, ids).options?.rows
        }
        if (
          Object.keys(this.options).length !== 0 &&
          this.options.name !== "emptyLayoutComponent" &&
          this.options.name !== "layoutComponent"
        ) {
          let res = handleFindLayoutComponentOptionsCols(pOptions, uid)
          if (this.options.name === "colsComponent") {
            return res
          } else {
            let result = handleFindLayoutComponentOptions(pOptions, uid)
            let res = result.find(it => it.elementInLayoutId === ids.elementInLayoutId)
            if (typeof ids.elementInAutoLayoutId === "number") {
              if (res && res.innerElement === 'cxAutoLayout') {// 当前元素在自动布局中，自动布局在自由布局中
                res = res.elementOptions.find(it => it.elementInAutoLayoutId === ids.elementInAutoLayoutId)
              } else { // 当前元素在自由布局中，自由布局在自动布局中
                res = this.getAttrById(stage, ids, "elementInAutoLayout")
              }
            }
            return res
          }
        } else {
          return null
        }
      }
    },
    checkOptName() {
      // return this.options?.name?.includes("realMap") && this.options.name !== "realMapComponent"
      return (
        (this.options?.name?.includes("realMap") && this.options.name !== "realMapComponent") || this.parentElementType
      )
    },
    showActiveType() {
      if (["cxTabs", "cxRadio", "cxRepeatNav", "cxButton"].includes(this.child_options?.innerElement)) {
        this.currentActiveTypeOptions = this.activeTypeOptions.filter(option => option.value !== "3")
      } else {
        this.currentActiveTypeOptions = this.activeTypeOptions
      }
      //收藏和点赞按钮判断
      let showType1 = this.child_options?.pluginName?.includes("likePlugin")
          || this.child_options?.pluginName?.includes("collectPlugin")
      return [
        "cxNavMenuVertical",
        "cxBreadCrumbs",
        "cxPagination",
        "cxRadio",
        "cxRepeatNav"
      ].includes(this.child_options?.innerElement) || showType1
    },
    hoverIsSameActive: {
      get() {
        return this.child_options.hoverIsSameActive
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverIsSameActive", false)
      }
    },
    subPagePreview() {
      return !!this.$store.state.states.getDataPageIds.pv
    },
    //面包屑栏展示
    breadcrumbShow() {
      if(this.handleList && this.handleList.length){
        return true
      }else{
        return false
      }
    },
    isSystemComponent: {
      get() {
        if(this.child_options?.isSystemComponent) {
          this.options.hasNoStyle = false
        }
        return this.child_options?.isSystemComponent
      }
    },
    innerElement: {
      get() {
        // 自由布局在调整内容后，数据配置始终激活，方便在改变单元格后更新数据
        if (this.child_options.innerElement) {
          this.getOptions()
        }
        return this.child_options.innerElement
      }
    },
    subPageGaphic() {
      // 原因是更多里的样式部分不是列表页的图文样式
      return (
        this.pageType === "listPage" &&
        (this.child_options.menuName === "图文列表" || this.child_options.menuName === "文本列表")
      )
    }
  },
  methods: {
    editComponentName(){
      this.showCheckIcon = true
      this.$nextTick(()=>{
        this.$refs.componentNameInp.focus()
      })
    },
    getComponentNameFocus(event) {
      event.currentTarget.select()
      this.showCheckIcon = true
    },
    changeComponentName($event, type) {
      this.showCheckIcon = false
      let ipt = document.getElementsByClassName("component-name-inp")[0]
      let newVal = type === 1 ? $event.target.value.trim() : ipt && ipt.value
      if (newVal === this.toolbarHeaderName || type === 2) {
        return
      }
      this.toolbarHeaderName = newVal
      // 存入后台
      this.$emit("save")
      this.getPublicId().then(publicId => {
        if (!publicId) {
          return
        }
        this.$API
          .updateAppAttr({
            param: {
              publicId: publicId,
              appName: this.toolbarHeaderName
            }
          })
          .then(res => {
            if (res.data.code === 1) {
              console.log("保存成功")
            }
          })
      })
    },
    async getPublicId() {
      const { websiteId, pageId, wfwfid } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(this.ids)
      console.log("this.child_options :>>", rectAttr, this.child_options)
      const appId = this.child_options?.appId
      this.publicId = this.child_options?.engineInstanceId || this.child_options?.publicId // 组件的publicId都是存到engineInstanceId里的
      if (this.publicId) return this.publicId
      if (!appId) return
      const { restUrl } = await getAppointCacheData.call(this, pageId, wfwfid, websiteId, appId)
      this.publicId = restUrl.data.data.engineInstance.publicId
      return this.publicId
    },
    moreClick() {
      this.$refs.localStyleComponent.showAllStyles()
    },
    initTabShow() {
      this.tabShow = {
        first: true,
        second: false,
        third: false,
        fourth: false,
        fifth: false,
        sixth: false,
        seventh: false
      }
    },
    getIds() {
      let ids = this.$store.state.states.activeID
      //初始化显示哪个tab
      this.initTabShow()
      this.getOptions()
      // 解决第一个画布已经删除后，没有container_id为0情况
      console.log("ids", this.$store.state.states.activeID)
      if (ids.container_id === null || typeof ids.container_id === "undefined") {
        return
      }
      let containers = this.$store.state[this.request_prefix].page.children
      let idsInContainers = false
      for (let i = 0; i < containers.length; i++) {
        if (containers[i].container_id === ids.container_id) {
          idsInContainers = true
          break
        }
      }
      if (!idsInContainers) {
        ids = {
          ...ids,
          container_id: containers[0].container_id
        }
        this.$store.commit("states/changeActiveID", ids)
        this.$store.dispatch(this.request_prefix + "/setContainerActive", ids)
      }
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        this.ids = idsInContainers ? this.$store.state.states.activeID : ids
      } else this.ids = null
    },
    getNewOptions() {
      if (this.$refs.setComponent.getOptionsHandle && typeof this.$refs.setComponent.getOptionsHandle === "function") {
        this.$refs.setComponent.getOptionsHandle("changeStyle")
      }
    },
    // 滚动右侧工具栏页面  关闭下拉弹框
    scrollToolbar() {
      let selectDropdown = document.getElementsByClassName("toolbar")[0].getElementsByClassName("el-input")
      for (let i = 0; i < selectDropdown.length; i++) {
        if (selectDropdown[i].classList.value.indexOf("is-focus") > -1) {
          selectDropdown[i].click()
        }
      }
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    toolbarClick() {},
    closeEdit() {
      this.$store.commit("states/changeToolBarStatus", false)
      this.$store.commit("states/changeAlignHelperStatus", false)
    },
    dragstart(e) {
      this.startPosition = {
        x: e.clientX,
        y: e.clientY,
        offsetX: e.offsetX,
        offsetY: e.offsetY
      }
    },
    dragend(e) {
      this.handdleChangeToolbarPosition(e)
    },
    handdleChangeToolbarPosition(e) {
      let [endX, endY, screenW, screenH, clientX, clientY] = [
        e.clientX,
        e.clientY,
        window.innerWidth,
        window.innerHeight,
        this.startPosition.offsetX,
        this.startPosition.offsetY
      ]
      let computedX = (((endX - clientX) / screenW) * 100).toFixed(2) + "vw"
      let computedY = (((endY - clientY) / screenH) * 100).toFixed(2) + "vh"
      this.$set(this.computedStyle, "left", computedX)
      this.$set(this.computedStyle, "top", computedY)
    },
    handleClick(tab) {
      Object.keys(this.tabShow).forEach(k => {
        // 自由布局在调整内容后，数据配置始终激活，方便在改变单元格后更新数据
        if (k === tab.name) {
          this.$set(this.tabShow, k, true)
        } else {
          this.$set(this.tabShow, k, false)
        }
      })
      if(tab.label === "数据") {
        this.$eventBus.$emit("update-toolbar-data")
      }
    },
    changeTop(ev) {
      let top = parseInt(ev.target.value)
      if (typeof top !== "number" || isNaN(top)) {
        const tarIds = { container_id: this.ids.container_id, rect_id: this.ids.rect_id }
        top = this.getAttrById(this.$store.state[this.request_prefix], tarIds).top
        ev.target.value = top
        return
      }

      this.$store.dispatch(this.request_prefix + "/setTop", {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        top: top
      })
    },

    changeLeft(ev) {
      let left = parseInt(ev.target.value)

      if (typeof left !== "number" || isNaN(left)) {
        const tarIds = { container_id: this.ids.container_id, rect_id: this.ids.rect_id }
        left = this.getAttrById(this.$store.state[this.request_prefix], tarIds).left
        ev.target.value = left
      }

      this.$store.dispatch(this.request_prefix + "/setLeft", {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        left: left
      })
    },

    changeWidth(ev) {
      let width = parseInt(ev.target.value)

      if (typeof width !== "number" || isNaN(width)) {
        const tarIds = { container_id: this.ids.container_id, rect_id: this.ids.rect_id }
        width = this.getAttrById(this.$store.state[this.request_prefix], tarIds).width
        ev.target.value = width
      }

      this.$store.dispatch(this.request_prefix + "/setWidth", {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        width: width
      })
    },

    changeHeight(ev) {
      let height = parseInt(ev.target.value)

      if (typeof height !== "number" || isNaN(height)) {
        const tarIds = { container_id: this.ids.container_id, rect_id: this.ids.rect_id }
        height = this.getAttrById(this.$store.state[this.request_prefix], tarIds).height
        ev.target.value = height
      }

      this.$store.dispatch(this.request_prefix + "/setHeight", {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        height: height
      })
    },
    getOptions() {
        let elementType = this.$store.state.states.elementType
          ? this.$store.state.states.elementType
          : this.request_prefix === "bigScreen"
            ? this.request_prefix + "Container"
            : null
        let result = {}
        switch (elementType) {
          case "swiperComponent":
            result.name = elementType
            result.lable = "轮播"
            result.showConfig = true
            result.showProductStyle = true // 可以收藏的组件，需要展示系统样式
            break
          case "cxSwiper3D":
            result.name = 'swiper3DComponent'
            result.lable = "3D轮播"
            result.showConfig = true
            result.hasNoData = true
            result.showProductStyle = false // 可以收藏的组件，需要展示系统样式
            break
          // case "cxLayoutCanvas":
          //   result.name = "layoutCanvasComponent"
          //   result.lable = "画布"
          //   result.onlyShowSet = true
          //   result.hideToolTipHeader = true
          //   break
          case "cxPageLayoutComponentCell":
            result.name = "cellPageLayoutComponent"
            result.lable = "布局"
            result.onlyShowSet = true
            result.hideToolTipHeader = true
            if (this.child_options?.options?.isAccordionLayoutCol) {
              result.hideToolTipHeader = false
              result.hasNoAnimate = true
            }
            break
          case "cxPageLayoutComponent":
            result.name = "cellPageLayoutComponent"
            result.lable = "布局"
            result.onlyShowSet = true
            result.hideToolTipHeader = true
            if (this.child_options?.options?.isAccordionLayoutRow) {
              result.lable = "手风琴布局"
              result.onlyShowSet = false
              result.showConfig = true
              result.hasNoStyle = true
              result.hasNoData = true
              result.hideToolTipHeader = false
              result.hasNoAnimate = true
            }
            break
          case "cxText":
            result.name = "textComponent"
            result.lable = "文本"
            result.hasNoStyle = true
            if (this.child_options?.loginType === "loginError") {
              result.hasNoData = true
            }
            break
          case "cxEditor":
            result.name = "editorComponent"
            result.lable = "文本"
            result.hasNoEvent = true
            result.hasNoStyle = true
            // result.hasNoData = true
            break
          case "cxNoteEditor":
            result.name = "noteEditorComponent"
            result.lable = "笔记编辑器"
            this.pageType !== "detailPage" && this.pageType !== "listPage" ? (result.onlyShowBaseSet = true) : ""
            result.hasNoStyle = true
            result.hasNoEvent = true
            result.hasNoAnimate = true
            break
          case "cxLogicText":
            result.name = "logicTextComponent"
            result.lable = "逻辑文本"
            result.hasNoStyle = true
            break
          case "cxTabs":
            if (this.child_options?.quoteFrom === "cxSelect") {
              result.name = "selectComponent"
            } else {
              result.name = "tabsComponent"
            }
            result.lable = "标签页"
            // result.onlyShowSet = true
            result.hasNoEvent = true
            // result.hasNoStyle = true
            // result.hasNoData = true
            result.showProductStyle = true // 可以收藏的组件，需要展示系统样式

            // 登录框、搜索组件 屏蔽设置tab
            this.child_options && this.child_options.singleTabs && !this.child_options.isPageLayoutTabs
              ? (result.showConfig = false)
              : (result.showConfig = true)
            // 自由布局里面的cxTabs
            if (this?.rectOptions?.categoryMode === CATEGORY_MODE.SAME) {
              result.showConfig = false
            }
            /* 普通的标签组件和搜索里的非业务标签组件 支持外接数据源 */
            if (!this.child_options?.searchType &&
            (result.showConfig === false &&
            (!isExist(this.ids.elementInLayoutId) || (isExist(this.ids?.elementInLayoutId) && !this.rectOptions?.appId)) ||
            this.rectOptions?.pluginName?.includes("searchComponentPlugin"))) result.hasNoData = false
            else result.hasNoData = true
            if (!result.hasNoData) {// 允许外接数据源
              this.$changeOptionsEV(true, "hasDataSource", false)
            } else if (this.child_options?.hasDataSource) {
              this.$changeOptionsEV(false, "hasDataSource", false)
            }
            break
          case "cxPagination":
            result.name = "paginationComponent"
            result.lable = "分页"
            // result.onlyShowSet = true
            // result.hasNoStyle = false
            result.hasNoData = true
            result.showProductStyle = true // 可以收藏的组件，需要展示系统样式
            break
          case "imageComponent":
            result.name = "imageComponent"
            result.lable = "图片"
            result.hasNoStyle = true
            if(this.child_options?.loginType) {
              result.hasNoData = true
            }
            break
          case "cxButton":
            console.log("cxButton")
            result.name = "buttonComponent"
            result.lable = "按钮"
            result.showProductStyle = true // 可以收藏的组件，需要展示系统样式
            if (this.child_options?.pluginName?.includes("drawerPlugin")) {
              result.showConfig = true
            }else if(this.child_options?.pluginName?.includes("getIpPlugin")){
              result.lable = "IP"
              result.hasNoData = true
              result.showProductStyle = false
            }
            if (this.child_options?.loginType === "loginShowHide") {
              result.hasNoData = true
            }
            break
          case "cxLabel":
            result.name = "labelComponent"
            result.lable = "状态标签"
            result.showConfig = true
            result.hasNoStyle = true
            break
          case "cxShape":
            result.name = "shapeComponent"
            result.lable = "形状"
            // result.onlyShowBaseSet = true
            break
          case "cxBorder":
            result.name = "borderComponent"
            result.lable = "边框"
            result.onlyShowBaseSet = true
            break
          case "cxAnimate":
            result.name = "animateComponent"
            result.lable = "动画装饰"
            result.onlyShowBaseSet = true
            break
          case "layoutComponent":
            // result.name = "layoutComponent"
            // result.lable = "自由布局"
            // result.showConfig = true
            result.name = "emptyLayoutComponent"
            result.lable = "自由布局"
            result.showConfig = true
            if (this.child_options && !this.isSystemComponent) {
              result.hasNoStyle = true
            }
            if (
              this.child_options?.hasOwnProperty("pluginName") &&
              this.child_options?.pluginName.indexOf("loginLayoutComponent") > -1
            ) {
              // 登录组件
              result.hasNoStyle = false
              // result.onlyShowScrollAnimate = true // 只显示滚动到动画
            }
            if (this.child_options?.componentTypeName === "cxSystemLogin") {
              // 登录框
              result.hasNoData = true
              result.onlyShowScrollAnimate = true
            }
            if (
              this.child_options?.hasOwnProperty("pluginName") &&
              this.child_options?.pluginName.indexOf("loginEngineComponentPlugin") > -1
            ) {
              // 登录引擎
              result.hasNoAnimate = true
              result.showConfig = false
              result.hasNoData = false
            }
            if(result.onlyShowScrollAnimate){
              result.hasNoAnimate = false
            }
            // if (
            //   this.child_options?.hasOwnProperty("pluginName") &&
            //   this.child_options?.pluginName.indexOf("searchComponentPlugin") > -1
            // ) {
            //   // 搜索组件
            //   result.showConfig = false
            // }
            if (this.child_options?.hasOwnProperty("name") && this.child_options?.name.indexOf("超星头像") > -1) {
              // 超星头像
              result.showConfig = false
              result.hasNoEvent = true
              result.hasNoData = true
              // result.onlyShowScrollAnimate = true // 只显示滚动到动画
            }
            break
          case "emptyLayoutComponent":
            // if (this.$store.state.states.activeID.uid) {
            //   result.name = "colsComponent"
            //   result.lable = "自由布局"
            // } else {
            result.name = "emptyLayoutComponent"
            result.lable = "自由布局"
            result.showConfig = true
            if (this.child_options && !this.isSystemComponent) {
              result.hasNoStyle = true
            }
            if (this.child_options?.menuName === "移动端导航栏") {
              result.hasNoData = true
              if(this.pageType === "listPage" || this.pageType === "detailPage") {
                result.showConfig = false
              }
            }
            console.log("this.child_options :>>", this.child_options)
            if (this.child_options?.componentTypeName === "cxSystemLogin") {
              // 登录框
              result.hasNoData = true
              result.onlyShowScrollAnimate = true
            }
            if (
              this.child_options?.hasOwnProperty("pluginName") &&
              this.child_options?.pluginName.indexOf("loginLayoutComponent") > -1
            ) {
              // 登录组件
              result.hasNoStyle = false
              // result.showConfig = false
              // result.hasNoEvent = true
              // result.hasNoData = true
              // result.onlyShowScrollAnimate = true // 只显示滚动到动画
            }
            // }
            if (
              this.child_options?.hasOwnProperty("pluginName") &&
              this.child_options?.pluginName.indexOf("loginEngineComponentPlugin") > -1
            ) {
              // 登录引擎
              result.hasNoAnimate = true
              result.showConfig = false
              result.hasNoData = false
            }
            if(result.onlyShowScrollAnimate){
              result.hasNoAnimate = false
            }
            if (
              (this.pageType === "listPage" || this.pageType === "detailPage") &&
              this.child_options?.hasOwnProperty("pluginName") &&
              this.child_options?.pluginName.indexOf("searchComponentPlugin") > -1
            ) {
              // 搜索组件
              result.showConfig = false
            }
            if (this.child_options?.hasOwnProperty("name") && this.child_options?.name.indexOf("超星头像") > -1) {
              // 超星头像
              result.showConfig = false
              result.hasNoEvent = true
              result.hasNoData = true
            }
            if (
              this.child_options?.hasOwnProperty("pluginName") &&
              this.child_options?.pluginName.indexOf("ListPageSearchComponentPlugin") > -1
            ) {
              // 列表页搜索
              result.showConfig = false
              result.hasNoData = true
            }
            break
          case "cxPageLayout":
            result.name = "pageLayoutComponent"
            result.lable = "通栏"
            result.onlyShowSet = true
            result.hideToolTipHeader = true
            if (
              this.child_options?.options?.inDocument === "header" ||
              this.child_options?.options?.inDocument === "relativeHeader"
            ) {
              result.lable = this.child_options?.options?.inDocument === "relativeHeader" ? "变换头部" : "头部"
              result.onlyShowSet = false
              result.showConfig = true
              result.hasNoData = true
              result.hideToolTipHeader = false
              result.hasNoStyle = true
            } else if (this.child_options?.options?.inDocument === "footer") {
              result.lable = "底部"
            } else if (this.child_options?.options?.inDocument === "anchor") {
              result.lable = "锚点"
              result.onlyShowSet = false
              result.hasNoStyle = true
              result.showConfig = true
              result.hasNoData = true
              result.hideToolTipHeader = false
            } else if (this.child_options?.options?.inDocument === "drawer") {
              // 抽屉
              result.name = "drawerComponent"
              result.lable = "抽屉"
              result.onlyShowSet = false
              result.showConfig = true
              result.hasNoData = true
              result.hasNoStyle = true
              result.hideToolTipHeader = false
            }
            result.hasNoAnimate = true
            break
          case "cxPageLayoutCell":
            result.name = "cellLayoutComponent"
            result.lable = "布局"
            result.onlyShowSet = true
            result.hasNoAnimate = true
            result.hideToolTipHeader = true
            if (this.child_options?.options?.isAccordionLayoutRow) {
              result.lable = "手风琴布局"
              result.onlyShowSet = false
              result.showConfig = true
              result.hasNoStyle = true
              result.hasNoData = true
              result.hideToolTipHeader = false
              // result.hasNoAnimate = false
            }
            if (this.child_options?.options?.isAccordionLayoutCol) {
              result.hideToolTipHeader = false
            }
            break
          case "colsComponent":
            result.name = "colsComponent"
            result.lable = "单元格"
            result.hasNoStyle = true
            break
          case "container":
            result.name = this.request_prefix === "bigScreen" ? "bigScreenContainer" : "container"
            result.lable = "画布"
            if (this.child_options?.inDocument === "header") {
              result.lable = "头部"
            } else if (this.child_options?.inDocument === "footer") {
              result.lable = "底部"
            }
            result.onlyShowSet = this.isPhoneFullScreen ? false : true
            break
          case "bigScreenContainer":
            result.lable = "画布"
            result.onlyShowSet = true
            break
          case "cxMore":
            result.name = "moreComponent"
            result.lable = "更多"
            result.hasNoStyle = true
            break
          case "cxBar":
            result.name = "barComponent"
            result.lable = "柱状图"
            break
          case "cxPie":
            result.name = "pieComponent"
            result.lable = "饼图"
            break
          case "cxLine":
            result.name = "lineComponent"
            result.lable = "折线图"
            break
          case "cxRadar":
            result.name = "radarComponent"
            result.lable = "雷达图"
            break
          case "cxMap":
            result.name = "mapComponent"
            result.lable = "3D地球"
            break
          case "cxRealMap":
            result.name = "realMapComponent"
            result.lable = "地图"
            result.showProductStyle = true // 可以收藏的组件，需要展示系统样式
            break
          case "cxMap3D":
            result.name = "cxMap3D"
            result.lable = "3D地图"
            break
          case "cxRealMapScatter":
            result.name = "realMapScatterComponent"
            result.lable = "涟漪图"
            break
          case "cxRealMapHot":
            result.name = "realMapHotComponent"
            result.lable = "区域热力图"
            break
          case "cxRealMapLines":
            result.name = "realMapLinesComponent"
            result.lable = "飞线层"
            break
          case "cxCloud":
            result.name = "cloudComponent"
            result.lable = "词云"
            break
          case "cxWeather":
            result.name = "weatherComponent"
            result.lable = "天气"
            result.hasNoData = true
            // result.onlyShowBaseSet = true
            break
          case "cxDate":
            result.name = "dateComponent"
            result.lable = "日期"
            result.onlyShowBaseSet = true
            break
          case "cxTable":
            result.name = "tableComponent"
            result.lable = "表格"
            result.showConfig = true
            break
          case "cxDigitRoll":
            result.name = "digitRollComponent"
            result.lable = "数字滚动"
            // result.hasNoStyle = true
            break
          case "cxVideo":
            result.name = "videoComponent"
            result.lable = "视频"
            result.hasNoStyle = true
            break
          case "cxIframe":
            result.name = "iframeComponent"
            result.lable = "内嵌网页"
            result.hasNoStyle = true
            // result.hasNoData = true
            break
          case "cxComment":
            result.name = "commentComponent"
            result.lable = "评论"
            result.hasNoStyle = true
            result.hasNoData = true
            break
          case "page":
            result.name = "page"
            result.lable = "页面"
            result.onlyShowSet = true
            result.onlyShowBaseSet = true
            break
          case "cxInput":
            result.name = "inputComponent"
            result.lable = "输入框"
            result.hasNoStyle = true
            break
          case "cxSelect":
            if (this.child_options?.quoteFrom && this.child_options.quoteFrom === "cxTabs") {
              // result.name = "tabsComponent"
              result.lable = "标签页"
            } else {
              result.lable = "下拉框"
              // result.hasNoStyle = true
              // 搜索的中自带的下拉框屏蔽右侧栏“数据”tab
              if(this.child_options?.searchType === "searchSelect"){
                result.hasNoData = true
              }
            }
            result.name = "selectComponent"
            break
          case "cxNavMenu":
            result.name = "navMenuComponent"
            result.lable = "多级菜单"
            this.hasNoStyle = true
            result.showConfig = true
            if (this.isLoginName) {
              result.hasNoData = true
            }
            if (!this.child_options?.appId) {
              result.showConfig = false
            }
            if (this.pageType === "listPage") {
              result.hasNoData = true
            }
            break
          case "cxNavMenuVertical":
            result.name = "navMenuVerticalComponent"
            result.lable = "树形菜单"
            // result.hasNoStyle = true
            result.showProductStyle = true // 可以收藏的组件，需要展示系统样式
            if (this.pageType === "listPage") {
              result.showConfig = true
              // 判断是否是列表页老模版中的多级菜单
              if (this.ids?.hasOwnProperty("directionIndex") && this.ids?.rect_id === 9999) {
                // 隐藏数据管理
                result.hasNoData = true
              } else {
                // 判断是否是新模版中的多级菜单
                let cxNavMenuVertical = this.$store.state[this.request_prefix]?.page?.children[0]?.children?.filter(
                  rect => {
                    return (
                      rect.shape === "cxNavMenuVertical" && !rect.options?.pluginName?.includes("searchComponentPlugin")
                    )
                  }
                )
                if (cxNavMenuVertical[0]?.rect_id === this.ids?.rect_id) {
                  result.hasNoData = true
                }
              }
            }
            if (this.pageType === 'detailPage') {
              result.hasNoData = true
            }
            break
          case "cxRepeatNav":
            result.name = "repeatNavComponent"
            result.lable = "平铺导航"
            this.hasNoStyle = true
            result.showConfig = true
            if (this.isLoginName) {
              result.hasNoData = true
            }
            break
          case "cxRadio":
            result.name = "radioComponent"
            result.lable = "单选"
            result.hasNoStyle = true
            result.hasNoData = true
            break
          case "cxHomeLine":
            result.name = "homeLineComponent"
            result.lable = "横线"
            // result.onlyShowSet = true
            result.onlyShowBaseSet = true
            break
          case "cxVerticalLine":
            result.name = "verticalLineComponent"
            result.lable = "竖线"
            result.onlyShowBaseSet = true
            break
          case "cxBreadCrumbs":
            result.name = "breadCrumbsComponent"
            result.lable = "面包屑"
            // result.onlyShowSet = true
            result.hasNoEvent = true
            // result.hasNoStyle = true
            // result.hasNoData = true
            result.showConfig = true
            if (this.pageType === "listPage" || this.pageType === "detailPage") {
              // 列表页搜索
              // result.showConfig = false
              result.hasNoData = true
            }
            break
          case "cxAudio":
            result.name = "audioComponent"
            result.lable = "音频"
            result.hasNoAnimate = true
            result.hasNoEvent = true
            // result.hasNoStyle = true
            break
          case "cxIcon":
            result.name = "iconComponent"
            result.lable = "图标"
            result.hasNoEvent = true
            result.hasNoStyle = true
            result.hasNoData = true
            break
          case "cxCalendar":
            result.name = "calendarComponent"
            result.lable = "日历"
            result.hasNoEvent = true
            result.showConfig = true
            // result.hasNoStyle = true
            // result.hasNoData = true
            break
          case "cxMultiFilter":
            result.name = "multiFilterComponent"
            result.lable = "多级筛选"
            result.showConfig = this.child_options?.model === "tree" ? true : false
            if (
              this.pageType === "listPage" &&
              !this.child_options?.pluginName?.includes("triggerMulitiFilter") &&
              !this.child_options?.pluginName?.includes("controlMulitiFilter")
            ) {
              result.hasNoData = true
            }
            break
          case "cxCode":
            result.name = "codeComponent"
            result.lable = "二维码"
            result.hasNoStyle = true
            result.showConfig = false
            break
          case "cxSort":
            result.name = "sortComponent"
            result.lable = "排序"
            result.hasNoData = true
            result.hasNoStyle = true
            result.showConfig = true
            break
          case "cxAutoLayout":
            result.name = "autoLayoutComponent"
            result.lable = "行布局"
            result.onlyShowBaseSet = true
            break
          case "cxDatePicker":
            result.name = "datePickerComponent"
            result.lable = "时间选择器"
            if(this.pageType === "listPage") {
              result.showConfig = true
            }
            // result.hasNoStyle = true
            result.hasNoData = true
          break
          case "cxDataGrid":
            result.name = "dataGridComponent"
            result.lable = "列表页数据"
            result.hasNoData = true
            result.hasNoStyle = true
            result.hasNoEvent = true
            result.showConfig = false
          break
          case "cxDataGridCell":
            result.name = "dataGridCellComponent"
            result.lable = "单元格"
            result.hasNoStyle = true
            result.hasNoEvent = true
            result.showConfig = false
            // result.hasNoAnimate = true
          break
          case "cxDanmaku":
            result.name = "danmaku"
            result.lable = "滚动词云"
            result.hasNoStyle = true
            result.showConfig = true
            break
          case "cxAnchorComponent":
            result.name = "anchorComponent"
            result.lable = "锚点"
            result.hasNoEvent = true
            result.hasNoData = false
            break
          case "grid":
            result.name = "grid"
            result.label = "栅格？？"
            result.onlyShowSet = true
            result.hasNoEvent = true
            result.hasNoStyle = true
            result.hasNoData = true
            result.hideToolTipHeader = false
            result.hasNoAnimate = true
            break
          case "cxReturn":
            result.name = "returnComponent"
            result.lable = "返回"
            result.onlyShowBaseSet = true
            result.hasNoStyle = true
            break
          case "cxShare":
            result.name = "shareComponent"
            result.lable = "分享"
            result.hasNoData = true
            // result.hasNoStyle = true
            result.showConfig = true
            result.showProductStyle = true
            break
          case "cxBaidumap":
            result.name = "baidumapComponent"
            result.lable = "百度地图"
            result.hasNoStyle = true
            break
          case null:
            result.onlyShowBaseSet = true
            break
          default:
            const menuConfig = toolbarMixins.menuConfig[elementType]
            if (menuConfig) {
              result.name = menuConfig.name
              result.lable = menuConfig.label
              this.parentElementType = menuConfig.parentMenuName || ""
            }
        }
        if ((this.request_prefix === "bigScreen" && elementType === null) || elementType === "bigScreenContainer") {
          result.name = "bigScreenContainer"
          result.lable = "画布"
          result.onlyShowSet = true
        }
        if ((this.request_prefix !== "bigScreen" && elementType === null) || elementType === "page") {
          result.name = "global"
          result.lable = "页面"
          const oldIds = { ...this.$store.state.states.activeID }
          // delete oldIds.container_id
          if (Object.values(oldIds).some(item => item !== null)) {
            const ids = {}
            for (let k in oldIds) {
              if (k !== "container_id") {
                ids[k] = null
              } else {
                ids[k] = oldIds.container_id
              }
            }
            this.$store.commit("states/changeActiveID", ids)
          }
          result.onlyShowSet = true
        }
        if ((elementType === null || elementType === "page") && this.subPagePreview) {
          result.name = "subPage"
          result.lable = "页面"
          result.onlyShowBaseSet = false
          result.showConfig = true
          result.onlyShowSet = true
          result.hasNoAnimate = true
          const oldIds = { ...this.$store.state.states.activeID }
          if (Object.values(oldIds).some(item => item !== null)) {
            const ids = {}
            for (let k in oldIds) {
              if (k !== "container_id") {
                ids[k] = null
              } else {
                ids[k] = oldIds.container_id
              }
            }
            this.$store.commit("states/changeActiveID", ids)
          }
        }
        this.activeName = "first"
        this.options = result
    },
    draggable() {
      return this.ids.container_id === null ? false : this.getRectAttribute.call(this, this.ids).draggable
    },
    // 打开自由布局组件设置项
    openLayoutComponentEdit(handle, index) {
      if (index === this.handleList.length - 1) return
      let changeId
      if (handle.ids) changeId = handle.ids
      // 有报错，先注释，使用冯驯的新的选中方案
      // 先放开 从组件点击选中单元格时没有清空内部组件的选中态
      this.clearAllActiveInCol(changeId, handle.shape)
      switch (handle.shape) {
        case "cxPageLayoutCell":
          // 当前被激活对象为布局时
          $(`#layout_${handle.ids.pageLayoutId}`).siblings(".layout-sets").find(".default-icon").click()
          break
        case "cxPageLayoutComponentCell":
          // 当前被激活对象为布局时
          // 此时已经不是唯一的了
          $(`#rect_id_${handle.ids.rect_id}_layout_${handle.ids.pageLayoutId}`).siblings(".layout-sets").find(".default-icon").click()
          break
        case "cxPageLayoutComponent":
          $(".layout-container.set_active").removeClass("set_active active")
          this.$store.dispatch(this.request_prefix + "/setActive", changeId)
          break
        case "cxPageLayout":
          let pageLayoutIndex = handle.ids.pageLayoutId
          // 需要考虑通栏 isShow 为false的情况
          let pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
          let hideLen = 0
          for(let i=0;i<pageLayoutList.length;i++){
            if(pageLayoutList[i].options.hasOwnProperty('isShow') && !pageLayoutList[i].options.isShow  ){
              hideLen++
            }
            if(pageLayoutIndex == i){
              pageLayoutIndex = i - hideLen
              break
            }
          }
          if (handle.name === "抽屉") {
            $(`.pageLayout_id_${pageLayoutIndex}`).find(".padding-block-top").click()
          } else if(handle.name === "弹出框") {
            this.clearAllActiveInCol(changeId, handle.shape)
            const sourceIds = this.$store.state[this.request_prefix].page.pageLayoutList[handle.ids.pageLayoutId].options.sourceIds
            this.$store.commit("states/changeActiveID", sourceIds)
            this.$store.commit("states/changeElementType", "cxButton")
            return
          } else {
            // 当前被激活对象为通栏时 通栏是通过 index 来定义激活项的
            $(`.page-layout-wrapper`).eq(pageLayoutIndex).find(".padding-block-top").click()
          }
          break
        default:
          if (isExist(this.ids.elementInAutoLayoutId) && isExist(this.child_options.elementInAutoLayoutId)) {
            let ids = {
              container_id: this.ids.container_id,
              rect_id: this.ids.rect_id,
            }
            if (isExist(this.ids.elementInLayoutId)) {
              ids = {
                container_id: this.ids.container_id,
                rect_id: this.ids.rect_id,
                elementInLayoutId: this.ids.elementInLayoutId,
                uid: this.ids.uid
              }
            }
            let rect = this.getAttrById(this.$store.state[this.request_prefix], ids)
            this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", ids)
          }
      }
      this.$store.commit("states/changeElementType", handle.shape)
      this.$store.commit("states/changeActiveID", changeId)
      if (handle.shape === "emptyLayoutComponent") {
        if (changeId.elementInAutoLayoutId !== undefined) {
          this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutActive", changeId)
        } else {
          this.$store.commit(this.request_prefix + "/ENABLE_ACTIVE", {
            ...changeId
          })
        }
      }
      // 设置单元格的activeCol 不然当有三层以上单元格时会一直悬浮前一个单元格
      if (handle.shape === "colsComponent") {
        this.$changeOptionsEV(changeId.uid, "activeCol", false, null, {
          container_id: changeId.container_id,
          rect_id: changeId.rect_id
        })
      }
      if (handle.shape === "cxAutoLayout") {
        if (changeId.elementInLayoutId !== undefined) {// 选中自由布局下的自动布局
          // this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", changeId)
          this.$store.dispatch(this.request_prefix + "/changeLayoutActive", {
            ...changeId,
            option_name: "isActive",
            option_val: true
          })
        } else if (changeId.elementInAutoLayoutId !== undefined) {// 自动布局中的自动布局
          // this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", {
          //   container_id: this.ids.container_id,
          //   rect_id: this.ids.rect_id,
          // })
          this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutActive", changeId)
        } else {
          // this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", {
          //   container_id: this.ids.container_id,
          //   rect_id: this.ids.rect_id,
          // })
          this.$store.dispatch(this.request_prefix + "/setActive", changeId)
        }
      }
      // 点击取消悬浮态
      let parentNode = this.getParentNode(handle)
      if (parentNode) {
        parentNode.removeClass("hover-active")
      }
      this.$store.commit("states/changeShowRightToolbarStatus", true)
    },
    clearAllActiveInCol(ids, shape) {
      //当前单元格中有激活组件时 在进行清除激活操作
      if (isExist(this.ids.directionIndex)) {
        let disableActiveLayoutTitle = {
          ...this.ids
        }
        this.$store.dispatch(this.request_prefix + "/layoutTitleDisableActive", disableActiveLayoutTitle)
      }

      if (shape === "colsComponent" || shape === "emptyLayoutComponent") {
        //当前单元格中有激活组件时 在进行清除激活操作
        let param = {
          ...ids,
          option_name: "isActive",
          option_val: "delAllActive"
        }
        this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
      } else if (shape === "swiperComponent") {
        // 清除轮播内组件激活状态
        let param = {
          ...ids,
          swiperContent_id: this.ids.swiperContent_id,
          elementInSwiperId: null
        }
        if (param.hasOwnProperty("swiperContent_id") && isExist(param.swiperContent_id)) {
          this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", param)
        }
        // 设置轮播激活状态 用于清除上一个选中组件的active
        this.$store.dispatch(this.request_prefix + "/setActive", {
          container_id: ids.container_id,
          rect_id: ids.rect_id
        })
      } else if(isExist(this.ids.rect_id)){
        this.$store.commit(this.request_prefix + "/DISABLE_ACTIVE", {
          ...this.ids
        })
      }
    },
    // 获取父级的dom元素
    getParentNode(handleInfo) {
      let parentNode
      switch (handleInfo.shape) {
        case "colsComponent":
          parentNode = $(`#${handleInfo.ids.uid}`)
          break
        case "cxPageLayoutCell":
          parentNode =
            handleInfo.ids.pageLayoutId.length === 1
              ? $(`.pageLayout_id_${handleInfo.ids.pageLayoutId}`)
              : $(`#layout_${handleInfo.ids.pageLayoutId}`)
          break
        case "cxPageLayoutComponentCell":
          parentNode =
            handleInfo.ids.pageLayoutId.length === 1
              ? $(`.pageLayout_id_${handleInfo.ids.pageLayoutId}`)
              : $(`#rect_id_${handleInfo.ids.rect_id}_layout_${handleInfo.ids.pageLayoutId}`)
          break
        case "cxPageLayout":
          let pageLayoutIndex =handleInfo.ids.pageLayoutId
          // 需要考虑通栏 isShow 为false的情况
          let pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
          let hideLen = 0
          for(let i=0;i<pageLayoutList.length;i++){
            if(pageLayoutList[i].options.hasOwnProperty('isShow') && !pageLayoutList[i].options.isShow  ){
              hideLen++
            }
            if(pageLayoutIndex == i){
              pageLayoutIndex = i - hideLen
              break
            }
          }
          parentNode = $(`.page-layout-wrapper`).eq(pageLayoutIndex)
          break
        case "page":
          parentNode = $(`#container_${handleInfo.ids.container_id}`)
          break
        default:
          if (handleInfo.ids.uid) {
            parentNode = $(
              `.container_id_${handleInfo.ids.container_id}-rect_id_${handleInfo.ids.rect_id}-uid_${handleInfo.ids.uid}-elementInLayoutId_${handleInfo.ids.elementInLayoutId}`
            )
          } else if (handleInfo.ids.elementInAutoLayoutId !== undefined) {
            parentNode = $(`.container_id_${handleInfo.ids.container_id}-rect_id_${handleInfo.ids.rect_id}-elementInAutoLayoutId_${handleInfo.ids.elementInAutoLayoutId}-path_${handleInfo.ids.path ? handleInfo.ids.path.join('') : handleInfo.ids.path}`)
          } else {
            parentNode = $(`.container_id_${handleInfo.ids.container_id}-rect_id_${handleInfo.ids.rect_id}`)
          }
      }
      return parentNode
    },
    mouseenterEv(handle, index) {
      if (index === this.handleList.length - 1) return
      let parentNode = this.getParentNode(handle)
      if (parentNode) {
        parentNode.addClass("hover-active")
      }
    },
    mouseleaveEv(handle, index) {
      if (index === this.handleList.length - 1) return
      let parentNode = this.getParentNode(handle)
      if (parentNode) {
        parentNode.removeClass("hover-active")
      }
    },
    backTopTitle() {
      this.$store.commit("states/changeElementType", this.parentElementType || "cxRealMap")
      this.initTabShow()
    },
    // 特殊处理，针对handleList中抽屉存在的时候，需要去掉布局这层数据
    removeLayoutHandle() {
      if (this.handleList.find(it => it.name === "抽屉") && this.handleList.find(it => it.name === "布局" || it.name === "内容区")) {
        this.handleList = this.handleList.filter(it => it.name !== "布局" && it.name !== "内容区")
      }
      const isTop = this.child_options?.pluginName?.includes("goTopPlugin")
      if(isTop && this.handleList.find(it => it.shape === "cxPageLayoutCell" || it.shape === "cxPageLayout")) {
        this.handleList = this.handleList.filter(it => it.shape !== "cxPageLayoutCell" && it.shape !== "cxPageLayout")
      }
      if(this.handleList.find(it => it.name === "弹出框")) {
        this.handleList = this.handleList.filter(it => it.shape !== "cxPageLayoutCell")
      }
    },
    onHideHeader(val) {
      this.options.onlyShowBaseSet = val
      this.options.hideToolTipHeader = val
    }
  }
}
</script>

<style scoped>

.component-name{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 30px);
}
.component-name-inp,
.component-name-text {
  padding: 6px 8px;
  height: 30px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.component-name-edit{
  padding: 0 8px;
  height: 30px;
  line-height: 26px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
.component-name-box span{
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;

}
.component-name-box,
.component-name-text{
  display: inline-block;
  width: calc(100% - 56px);
}
.component-name-edit,
.component-name-inp{
  width: 100%;
}
.component-name-text {
  width: calc(100% - 56px);
}
/* .component-name-inp {
  width: 100%;
  &.edit {
    width: calc(100% - 56px);
  }
  transition: width 0.2s linear;
} */
.component-name-edit:hover,
.component-name-inp:hover {
  outline: 1px solid #e9e9e9;
}
.component-name-inp:focus {
  box-shadow: inset 0 0 0 2px var(--themeColor);
}
.paddinglr20 {
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
}
.hide_Header/deep/ .el-tabs__header {
  display: none;
}
.toolbar .hide-toolBar-header/deep/ .el-tabs__header {
  margin: 0 8px;
}
/* :root {
        --toolbar-width: 20vw;
    } */
.del {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 17px;
  right: 16px;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
}

.toolbar/deep/ .el-collapse-item__content {
  padding: 16px;
  box-sizing: border-box;
}
.toolbar/deep/ .el-collapse-item__header {
  padding: 0 24px;
  box-sizing: border-box;
}
/*.toolbar:not(.bigScreen-toolbar) {*/
.toolbar {
  overflow-y: auto;
  /*left: 90vw;*/
  width: 260px;
  box-shadow: 0 0 2px #aaa;
  box-sizing: border-box;
  background-color: white;
  z-index: 999;
  /* border-radius: 8px; */
}
.home .toolbar {
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px 16px rgba(0, 0, 0, 0.03);
}
.toolbar /deep/ .size-inp-wrap {
  width: 39%;
}
.toolbar /deep/ .size-inp-wrap:not(:last-child) {
  margin-right: 6%;
}
.toolbar /deep/ .size-inp {
  /*width: calc(100% - 24px);*/
  height: 32px;
}
.toolbar-wh-row {
  margin-bottom: 20px;
}

.setting {
  display: flex;
  flex-direction: column;
}

.set-item {
  margin-bottom: 20px;
}

.toolbar-row-title {
  font-size: 14px;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  margin: 0 0 12px 0;
  color: #1a173b;
}

.toolbar-position-inp,
.toolbar-size-inp {
  font-size: 14px;
  display: inline-block;
  position: relative;
  margin-right: 20px;
}

.toolbar-size-inp input,
.toolbar-position-inp input {
  width: 50px;
  display: inline-block;
  border: 1px solid #bfbfca;
  margin: 0 8px;
  line-height: 24px;
  padding: 0 12px;
  box-sizing: border-box;
}

.toolbar-size-inp input[disabled],
.toolbar-position-inp input[disabled] {
  border: 1px solid #dcdce7;
  color: #aaaaaa;
}

.position-lock-icon,
.size-lock-icon {
  position: absolute;
  bottom: 3px;
  right: 17px;
  cursor: pointer;
}

.size-lock-icon {
  bottom: 2px;
  right: -3px;
}

.toolbar-check-inp {
  color: #445477;
  font-size: 13px;
  width: 180px;
  display: inline-block;
  margin: 2px 0;
}

.toolbar-row-title + label {
  margin-top: 5px;
}

.toolbar-check-inp input {
  border: 1px solid #bfbfca;
}

.to-top-icon,
.to-bottom-icon {
  display: inline-block;
  margin-right: 10px;
  padding: 0 12px;
  height: 24px;
  text-align: center;
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
  background-color: #fff;
}

.optionName {
  width: 60px;
}
.toolbar {
  height: 100%;
  overflow-y: hidden;
}
.toolbar/deep/ .el-tabs .el-collapse-item__header {
  /*height: 36px;*/
  /*line-height: 36px;*/
  font-weight: 600;
  color: var(--textColor);
}
.appStage-toolbar/deep/ .el-tabs .el-collapse-item__header,
.stage-toolbar/deep/ .el-tabs .el-collapse-item__header {
  position: relative;
  height: 34px;
  line-height: 34px;
  padding: 0 12px 0 30px;
}
.toolbar/deep/ .el-tabs {
  height: 100%;
}
.toolbar/deep/ .el-tabs__content::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.toolbar/deep/ .el-tabs__content {
  height: calc(100% - 86px);
  overflow-y: auto;
  padding: 0 0 20px 0;
  box-sizing: border-box;
  -ms-overflow-style: none; /* IE 10+ */
}
.toolbar .hide-toolBar-header/deep/ .el-tabs__content,
.toolbar .hide_Header/deep/ .el-tabs__content {
  height: calc(100% - 40px);
}

.toolbar .breadcrumb-show.hide-toolBar-header/deep/ .el-tabs__content,
.toolbar .breadcrumb-show.hide_Header/deep/ .el-tabs__content{
  height: calc(100% - 80px);
}
.toolbar .breadcrumb-show/deep/ .el-tabs__content {
  height: calc(100% - 126px);
}
/* header-name-hide 组件名称不展示，例如导航菜单的一级二级导航设置 */
.toolbar .breadcrumb-show.hide-toolBar-header.header-name-hide/deep/ .el-tabs__content{
  height: calc(100% - 40px);
}

.toolbar/deep/ .template-styles .el-collapse-item,
.toolbar/deep/ .el-tabs__content .el-collapse-item .el-collapse-item {
  border-top: none !important;
}
.toolbar/deep/ .template-styles .el-collapse .el-collapse-item__content,
.toolbar/deep/ .el-collapse-item__content .el-collapse-item__content {
  padding: 0;
}
.toolbar/deep/ .template-styles .el-collapse-item__content,
.toolbar/deep/ .el-collapse-item.paddingb_4 .el-collapse-item__content {
  padding-bottom: 4px;
}
.toolbar/deep/ .el-collapse-item.padding_0 .el-collapse-item__content {
  padding: 0px;
}
/*设置面板的样式*/
.toolbar/deep/ .el-tabs__content .el-collapse-item {
  padding: 0;
  box-sizing: border-box;
  background-color: var(--elCollapseItemHeaderBgColor);
  border-top: 1px solid var(--elCollapseItemBorderColor);
}
.stage-toolbar/deep/ .el-tabs__content .el-collapse-item,
.appStage-toolbar/deep/ .el-tabs__content .el-collapse-item {
  border-top: none;
}
.toolbar .toolbar-header {
  background: var(--toobarTopBgColor) !important;
  line-height: 48px;
  height: 48px;
  padding: 0 22px;
  color: var(--elCollapseItemHeaderColor);
  font-weight: 500;
  font-size: 16px;
  cursor: move;
}
.toolbar .toolbar-header {
  cursor: default;
}
.appStage-toolbar .toolbar-header,
.stage-toolbar .toolbar-header {
  background: #ffffff !important;
  line-height: 38px;
  height: 38px;
  padding-left: 8px;
  padding-right: 26px;
  font-size: 15px;
}
.toolbar .toolbar-header {
  cursor: default;
}
.toolbar .toolbar-header .icon {
  width: 24px;
  height: 24px;
  font-size: 19px;
  margin-left: 4px;
  color: var(--themeColor);
  display: inline-flex;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid;
  border-color: var(--themeColorDisabled);
  border-radius: 4px;
  justify-content: center;
  align-items: center;
}
.toolbar .toolbar-header .icon:hover {
  background-color: var(--themeColorSelectBg);
}
.toolbar/deep/ .el-tabs__header {
  margin: 5px 8px;
}
.toolbar/deep/ .el-tabs__item {
  font-size: 15px;
  line-height: 22px;
  padding: 0;
}
.toolbar/deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  margin-left: 3px;
}
.toolbar/deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
  margin-right: 3px;
}
.toolbar/deep/ .el-collapse-item__content {
  background: var(--elCollapseItemWrapBgColor);
  padding: 12px 16px;
}
.toolbar/deep/ .el-tabs__item:hover {
  color: var(--elCollapseItemContentColor);
}

.toolbar/deep/ .el-tabs__item.is-active {
  font-weight: 600;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.8);
  line-height: 34px;
}

.toolbar/deep/ .el-tabs__active-bar {
  /* width: 0 !important; */
  height: 30px;
  /* border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 8px solid #fff; */
  content: "";
  position: absolute;
  z-index: 0;
  top: 3px;
  left: 3px;
  /* bottom: -18px; */
  background-color: #ffffff;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.toolbar /deep/ .el-tabs__nav {
  display: flex;
  float: none;
  user-select: none;
}
.toolbar/deep/ .el-tabs__nav-wrap {
  background: #f3f3f3;
  border-radius: 8px;
}
.toolbar/deep/ .el-tabs__nav-wrap::after {
  display: none;
}
.toolbar/deep/ .el-tabs__item {
  flex: 1;
  text-align: center;
  line-height: 36px;
  /*padding: 0 12px;*/
  height: auto;
  border-radius: 6px;
  padding-right: 3px;
  font-weight: 400;
}
.toolbar/deep/ .el-tabs__item:not(:nth-child(2))::before {
  position: absolute;
  left: -1px;
  top: 50%;
  transform: translateY(-50%);
  content: "";
  display: block;
  width: 1px;
  height: 14px;
  background: rgba(0, 0, 0, 0.12);
}
.toolbar/deep/ .el-tabs__item.is-active::before {
  display: none;
}
.toolbar/deep/ .el-tabs__item.is-active + .el-tabs__item::before {
  display: none;
}
.toolbar/deep/ .el-switch {
  width: 50px;
}
.toolbar/deep/ .switch-btn-group {
  border-radius: 4px;
  overflow-y: hidden;
  display: flex;
}
.toolbar/deep/ .switch-btn.active {
  background: var(--themeColor);
  font-size: 14px;
  color: #fff;
}
.toolbar/deep/ .switch-btn {
  display: inline-block;
  background: var(--themeColorSelectBg);
  padding: 6px 10px;
  font-size: 14px;
  line-height: 20px;
  color: var(--themeColor);
  flex: 1;
  text-align: center;
  cursor: pointer;
}
.toolbar/deep/ .title {
  position: relative;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.8);
}
.toolbar/deep/ .unfold-btn {
  width: 20px;
  height: 20px;
  background-image: url("../../../assets/images/arrows-up.png");
  transform: rotateY(90deg);
  position: absolute;
  top: 0;
  right: 0;
}
.toolbar/deep/ .fold-btn {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.toolbar/deep/ .shape-list .shape {
  width: 60px;
  text-align: center;
  cursor: pointer;
}
.toolbar/deep/ .shape-list .shape .shape-border {
  padding: 3px;
  border: 0.8px solid #e9e9e9;
  background: #ffffff;
  border-radius: 3.2px;
  margin-bottom: 8px;
  box-sizing: border-box;
}
.toolbar/deep/ .shape-list .shape .shape-border.select {
  border: 2px solid var(--themeColor);
}
.toolbar/deep/ .shape-list .shape img {
  width: 100%;
  height: 100%;
}
.toolbar/deep/ .shape-list .shape .shape-text {
  font-size: 12px;
  line-height: 17px;
  color: rgba(0, 0, 0, 0.6);
}
.bigScreen-toolbar.toolbar/deep/ .shape-list .shape .shape-text {
  color: rgba(255, 255, 255, 0.6);
}
.toolbar/deep/ .radius_bg_1 {
  width: 24px;
  height: 24px;
  background: url("../../../assets/images/radius_left_top.png");
}
.toolbar/deep/ .radius_bg_2 {
  width: 24px;
  height: 24px;
  background: url("../../../assets/images/radius_right_top.png");
}
.toolbar/deep/ .radius_bg_3 {
  width: 24px;
  height: 24px;
  background: url("../../../assets/images/radius_right_bottom.png");
}
.toolbar/deep/ .radius_bg_4 {
  width: 24px;
  height: 24px;
  background: url("../../../assets/images/radius_left_bottom.png");
}
.toolbar/deep/ .home_radius {
  position: relative;
  display: block;
  width: 6px;
  height: 6px;
  margin-left: 6px;
  margin-right: 18px;
  transform: scale(1.1);
}
.toolbar/deep/ .home_radius::before {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  width: 12px;
  height: 12px;
  box-shadow: -5px -5px 0 -3px var(--themeColor), 5px 5px 0 -3px var(--themeColorDisabled),
    5px -5px 0 -3px var(--themeColorDisabled), -5px 5px 0 -3px var(--themeColorDisabled);
  left: -3px;
  top: -3px;
}
.toolbar/deep/ .home_radius.bg_2::before {
  box-shadow: -5px -5px 0 -3px var(--themeColorDisabled), 5px 5px 0 -3px var(--themeColorDisabled),
    5px -5px 0 -3px var(--themeColor), -5px 5px 0 -3px var(--themeColorDisabled);
}
.toolbar/deep/ .home_radius.bg_3::before {
  box-shadow: -5px -5px 0 -3px var(--themeColorDisabled), 5px 5px 0 -3px var(--themeColor),
    5px -5px 0 -3px var(--themeColorDisabled), -5px 5px 0 -3px var(--themeColorDisabled);
}
.toolbar/deep/ .home_radius.bg_4::before {
  box-shadow: -5px -5px 0 -3px var(--themeColorDisabled), 5px 5px 0 -3px var(--themeColorDisabled),
    5px -5px 0 -3px var(--themeColorDisabled), -5px 5px 0 -3px var(--themeColor);
}
.toolbar/deep/ .border-radius-header {
  position: relative;
  line-height: 30px;
}
.toolbar/deep/ .border-radius-btn {
  padding: 3px;
  border-radius: 4px;
  width: 62px;
  height: 30px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  cursor: pointer;
  background: rgba(243, 243, 243, 1);
  box-sizing: border-box;
}
.toolbar/deep/ .grid-type-btn {
  background: #f0f0f0;
}
.toolbar/deep/ .border-radius-btn span {
  margin-left: 1px;
  width: 26.5px;
  height: 24px;
  display: inline-block;
  line-height: 24px;
  text-align: center;
  vertical-align: top;
  color: var(--thirdTextColor);
  border-radius: 3px;
}
.toolbar/deep/ .border-radius-btn span:first-child {
  margin-left: 0;
}
.toolbar/deep/ .border-radius-btn span:hover {
  background: var(--inputBackGround);
  color: var(--textColor);
}
.toolbar/deep/ .border-radius-btn span.select {
  background: var(--inputBackGround);
  color: var(--textColor);
}
.toolbar/deep/ .icon-portal-full-screen1.select::before {
  color: var(--themeColor);
}
.toolbar/deep/ .icon-portal-adjustment1.select::before {
  color: var(--themeColor);
}
.toolbar/deep/ .border-image {
  width: 200px;
}
/*.toolbar/deep/ .setting-item .content .upload {*/
/*  width: 160px;*/
/*  height: 90px;*/
/*}*/
/*.toolbar/deep/ .setting-item .content .upload {*/
/*  width: 108px;*/
/*  height: 90px;*/
/*}*/
.toolbar/deep/ .card {
  /*display: block;*/
  padding: 16px;
  background: #f7f7f7;
  border-radius: 4px;
  border: none;
}
.bigScreen-toolbar/deep/ .title14_32,
.bigScreen-toolbar/deep/ .title12_17,
.bigScreen-toolbar/deep/ .title14_20 {
  color: inherit;
}
.toolbar/deep/ .setting-item .ml24 {
  margin-left: 2px;
  margin-right: 10px;
}
.bigScreen-toolbar/deep/ .card {
  /*display: block;*/
  padding: 8px;
}
.toolbar/deep/ .common_btn_28_20 {
  padding: 5px 4px;
}
.toolbar/deep/ .card {
  background: var(--cardBgColor);
  padding: 16px;
  border: 1px solid #e9e9e9;
}
.toolbar.card .el-slider__runway {
  background: var(--elCollapseItemWrapBgColor);
}
.toolbar/deep/ .custom-button-bg {
  display: inline-block;
  vertical-align: middle;
}
.toolbar/deep/ .el-radio {
  margin-right: 10px;
  margin-top: 4px;
  margin-bottom: 4px;
}
.toolbar/deep/ .card .repeat-style-ul > li {
  margin-right: 16px;
}
.toolbar/deep/ .repeat-style-ul > li {
  margin-right: 20px;
}
.toolbar/deep/ .card .repeat-style-ul > li {
  margin-right: 12px;
}
.toolbar/deep/ .el-collapse,
.toolbar/deep/ .el-collapse-item__wrap {
  border: none;
}
.toolbar/deep/ .el-collapse-item__header {
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  border: none;
  user-select: none;
}
.stage-toolbar/deep/ .el-tabs .el-collapse-item__header .el-collapse-item__arrow,
.appStage-toolbar/deep/ .el-tabs .el-collapse-item__header .el-collapse-item__arrow {
  /* display: none; */
  transform: rotate(0);
  color: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 12px;
}
.stage-toolbar/deep/ .el-tabs .el-collapse-item__header > .el-collapse-item__arrow::before {
  content: "\e791";
}
.appStage-toolbar/deep/ .el-tabs .el-collapse-item__header > .el-collapse-item__arrow::before {
  content: "\e791";
}
.stage-toolbar/deep/ .el-tabs .el-collapse-item__header .el-collapse-item__arrow.is-active {
  transform: rotate(90deg);
}
.appStage-toolbar/deep/ .el-tabs .el-collapse-item__header .el-collapse-item__arrow.is-active {
  transform: rotate(90deg);
}
.more-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--thirdTextColor);
  font-weight: 400;
}
.more-btn:hover {
  color: var(--themeColor);
}
::v-deep .el-collapse-item.is-active .el-collapse-item__wrap {
  overflow: visible;
}
.animate-tab-pane {
  height: 100%;
}
.animate-tab-pane > div {
  //height: calc(100% + 88px);
}
.element-crumbs {
  padding: 8px;
  line-height: 24px;
  border-bottom: 1px solid #e9e9e9;
  user-select: none;
}
.element-crumbs .el-breadcrumb__item {
  display: flex;
  align-items: center;
  padding-left: 4px;
  font-size: 13px;
}
.element-crumbs .el-breadcrumb__item:not(:last-child) {
  cursor: pointer;
}
::v-deep .element-crumbs .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  cursor: default !important;
}
::v-deep .element-crumbs .el-breadcrumb__inner {
  display: flex;
  align-items: center;
  color: var(--subTextColor);
}
::v-deep .element-crumbs .el-breadcrumb__inner .icon {
  margin-right: 2px;
}
::v-deep .element-crumbs .el-breadcrumb__separator {
  margin: 0;
  margin-left: 4px;
  color: var(--subTextColor);
  font-size: 14px;
}
::v-deep .element-crumbs .el-breadcrumb__item:not(:last-child):hover .el-breadcrumb__inner {
  color: var(--themeColor);
}
</style>
<style>
.toolbar .el-collapse-item.paddingtb8 .el-collapse-item__content {
  padding: 8px 16px;
}
.nextlinemt8 > div > div.mt16 {
  margin-top: 8px;
}
.hover-same-active {
  margin: 0 0 8px 55px;
  height: 18px;
}
.rect-active-slider {
  padding: 8px 12px;
}
</style>
